import { FC } from 'react';
import { MainArea, TopArea, Page, Splash } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Selectors as RouterSelectors } from 'router';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { State } from 'store';
import { getActiveClientFromStateAndLevel } from 'sections/client-management/utils/ClientHelpers';
import { Site } from 'sections/client-management/entities';

const StyledSplashContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 750px;
  margin: 0 auto;
  text-align: center;
`;

interface IStateProps {
  site?: Site;
}

const SiteBlacklist: FC<IStateProps> = ({ site }) => {
  const { t } = useTranslation();
  return (
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>
      <Page padding={0}>
        <StyledSplashContainer>
          <Splash
            imageUrl="/images/site-splash.svg"
            heading={t('settings.blacklist.noBlacklistHeading')}
            description={site ? t('settings.blacklist.noBlacklistDescription', { site: site.name }) : null}
            imageHeight={200}
          />
        </StyledSplashContainer>
      </Page>
    </MainArea>
  );
};

const mapStateToProps = (state: State): IStateProps => {
  const hasLevel = RouterSelectors.getClientLevel(state);
  const site = hasLevel === 'sites' ? getActiveClientFromStateAndLevel(state, hasLevel) : null;
  return {
    site,
  };
};

export default connect(mapStateToProps)(SiteBlacklist);
